import { render } from "./PeopleSearchResults.vue?vue&type=template&id=0852e489"
import script from "./PeopleSearchResults.vue?vue&type=script&lang=js"
export * from "./PeopleSearchResults.vue?vue&type=script&lang=js"
script.render = render

export default script